import * as Yup from 'yup'

export const ResearchContactFormValidationSchema = Yup.object().shape({
    email: Yup.string().email('f:validation:emailAddress').required('f:validation.required'),
    subject: Yup.string().required('f:validation.required'),
    message: Yup.string().required('f:validation.required')
})